module.exports = __webpack_public_path__ + "media/images/Cafod-Logo-strap-2019-Light-blue-144d08bdba2d5083be1ae5cc3ada50cf.png";